import React from 'react';
import PropTypes from 'prop-types';
import { Autocomplete, TextField } from '@mui/material';
import { Search, X } from 'lucide-react';
import { cn } from '../../../../../lib/utils';

function EmployeesFilter({
  employeesOptions,
  pickedEmployees,
  fetchEmployees,
  setPickedEmployees,
}) {
  return (
    <Autocomplete
      multiple
      options={employeesOptions}
      value={pickedEmployees}
      getOptionLabel={(option) => option.email || ''}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      onChange={(_, newValue) => setPickedEmployees(newValue)}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Filter by employees..."
          size="small"
          onChange={fetchEmployees}
          sx={{
            '& .MuiOutlinedInput-root': {
              backgroundColor: 'hsl(var(--background))',
              borderRadius: '0.5rem',
              fontSize: '0.875rem',
              '& fieldset': {
                borderColor: 'hsl(var(--border))',
              },
              '&:hover fieldset': {
                borderColor: 'hsl(var(--border))',
              },
              '&.Mui-focused fieldset': {
                borderColor: 'hsl(var(--primary))',
                borderWidth: '1px',
              },
            },
            '& .MuiInputBase-input': {
              color: 'hsl(var(--foreground))',
              '&::placeholder': {
                color: 'hsl(var(--muted-foreground))',
                opacity: 1,
              },
            },
          }}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <>
                <Search className="h-4 w-4 text-muted-foreground mr-2" />
                {params.InputProps.startAdornment}
              </>
            ),
          }}
        />
      )}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <span
            key={option.id}
            className={cn(
              'inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-xs font-medium',
              'bg-primary/10 text-primary',
            )}
            {...getTagProps({ index })}
          >
            {option.email}
            <X className="h-3 w-3 cursor-pointer hover:text-primary/80" />
          </span>
        ))
      }
      sx={{
        '& .MuiAutocomplete-tag': {
          margin: '2px',
        },
      }}
    />
  );
}

EmployeesFilter.propTypes = {
  employeesOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      email: PropTypes.string,
    }),
  ).isRequired,
  pickedEmployees: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      email: PropTypes.string,
    }),
  ).isRequired,
  fetchEmployees: PropTypes.func.isRequired,
  setPickedEmployees: PropTypes.func.isRequired,
};

export default EmployeesFilter;
